<template>
  <not-logged-in-view>
    <b-form novalidate class="sign-in__form" @submit="submit">
      <b-form-group class="text-center">
        <b-img src="~@/assets/images/lv_logo.png" alt="LV" class="lv-logo" />
      </b-form-group>
      <b-form-group
        label="Username:"
        label-for="username"
        :class="{ 'form-group--error': $v.signIn.username.$error }"
      >
        <b-form-input
          id="username"
          v-model="signIn.username"
          type="text"
          @input="$v.signIn.username.$touch()"
        />
        <span v-show="!$v.signIn.username.required" class="form-group__message">
          Username is required
        </span>
      </b-form-group>
      <b-form-group
        label="Password:"
        label-for="password"
        :class="{ 'form-group--error': $v.signIn.password.$error }"
      >
        <b-form-input
          id="password"
          v-model="signIn.password"
          class="form-control--password"
          :type="showPassword ? 'text' : 'password'"
          @input="$v.signIn.password.$touch()"
        />
        <span class="show-password" @click="showPassword = !showPassword">
          {{ showPassword ? 'HIDE' : 'SHOW' }}
        </span>
        <span v-show="!$v.signIn.password.required" class="form-group__message">
          Password is required
        </span>
      </b-form-group>
      <b-form-group class="text-center">
        <b-button
          type="submit"
          class="sign-in__button"
          :disabled="$v.signIn.$invalid"
          @click.prevent="submit"
        >
          Login
        </b-button>
        <div class="sign-in__forgot-pass">
          <router-link :to="{ name: 'resetPassword' }" class="pa-3">
            Forgot your password?
          </router-link>
        </div>
      </b-form-group>
      <b-form-group v-if="error">
        <b-alert variant="danger" show>
          {{ error }}
        </b-alert>
      </b-form-group>
    </b-form>
  </not-logged-in-view>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import NotLoggedInView from '@/components/shared/not-logged-in-view';

const INVALID_CREDS_ERROR_MSG = 'Invalid username or password.';

export default {
  name: 'SignIn',
  components: { NotLoggedInView },
  data() {
    return {
      signIn: {
        username: '',
        password: ''
      },
      showPassword: false,
      error: ''
    };
  },
  validations: {
    signIn: {
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    submit() {
      this.$store
        .dispatch('auth/signIn', {
          username: this.signIn.username,
          password: this.signIn.password
        })
        .then(() => {
          this.$router.push(this.$store.state.backToPath);
        })
        .catch(() => {
          this.error = INVALID_CREDS_ERROR_MSG;
        });
    }
  }
};
</script>
